module.exports = __webpack_public_path__ + "img/rank3.5003e818.png";